import { render, staticRenderFns } from "./new-contact.vue?vue&type=template&id=e698ac96"
import script from "./new-contact.vue?vue&type=script&lang=js"
export * from "./new-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports